<template>
  <v-container style="width: 900px">
    <v-data-table
        :headers="tableHeaders"
        :items="measurementItems"
        :loading="loading"
    >
      <template v-slot:item="{ item }">
        <tr
            class="text-left"
            :class="{'grey lighten-3 grey--text': item.selected}"
        >
          <td>
            {{ item.number + ' ' + item.name }}
          </td>
          <td>
            {{ item.quantity }}
          </td>
          <td>
            {{ languageData.measureTypes[item.uom.value] }}
          </td>
          <td>
            {{ item.price }}
          </td>
          <td>
            {{ item.qty_uom }}
          </td>
          <td>
            {{ item.uom_to_fv }}
          </td>
          <td>
            {{ item.total_net }}
          </td>
          <td>
            <v-btn
                :disabled="item.selected"
                @click="addMeasurementItem(item)"
                icon>
              <v-icon color="primary">add</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script type="text/javascript">
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../event-bus/eventBus";

export default {
  name: "MeasurementItemsTable",
  props: {
    layout: String,
    tableHeaders: Array,
    invoiceItems: Array,
  },
  data() {
    return {
      selectedEstimations: [],
    }
  },
  computed: {
    ...mapState("getEstimate", {
      estimations: state => state.estimationsData
    }),
    ...mapState("getEstimate", {
      loading: state => state.dataGetEstimationsFetching
    }),
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    measurementItems() {
      return this.flattenedEstimations(this.estimations);
    },
  },

  methods: {
    ...mapActions("getHeadersMeasurementItems", ["getHeadersMeasurementItemsRequest"]),

    flattenedEstimations(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.flattenedEstimations(children) : children)

      flattenArr.forEach((el) => { // determine if estimation item is in invoiceItems
        return this.invoiceItems.find(x => x.id === el.id && x.measurementItemId !== null && x.measurementItemId === el.measurementItemId) ? el.selected = true : el.selected = false;
      });

      return flattenArr.filter((e) => {
        if(typeof (e.vat) !== 'object') {
          e.vat = this.vatData.find(({value}) => value == e.vat);
        }

        return e.visibleInput === true && e.measurementDetails.length > 0; // determine if estimation has visible inputs
      });
    },
    addMeasurementItem(item) {
      eventBus.$emit('addEstimationItem', {item, isMeasurement: true});
    },
    flattenedEstimationItems() {
      return this.flattenedEstimations(this.estimations)
    },
  },
  mounted() {
    eventBus.$on("searchMeasurements", () => {
      this.getHeadersMeasurementItemsRequest({creds: {language: this.getCurrentLanguage}})
    })
  }

}
</script>